/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Status_Combining_SegmentsInputs */



/**
* | output |
* | --- |
* | "Combining audio segments..." |
*
* @param {Audio_Description_Export_Status_Combining_SegmentsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_status_combining_segments = /** @type {((inputs?: Audio_Description_Export_Status_Combining_SegmentsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Status_Combining_SegmentsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Assemblage des segments audio...")
	if (locale === "de") return /** @type {LocalizedString} */ ("Audiosegmente kombinieren...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Combinazione di segmenti audio...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Объединение аудиофрагментов...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Combinando segmentos de audio...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("合并音频片段……")
	if (locale === "ja") return /** @type {LocalizedString} */ ("オーディオ セグメントを結合しています...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ऑडियो खंडों को संयोजित करना...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Combinando segmentos de áudio...")
	return /** @type {LocalizedString} */ ("Combining audio segments...")
});